function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeartClipboard = function SvgHeartClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56676"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56613"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.354 23.764a1.214 1.214 0 0 1-.948-.479A1.674 1.674 0 0 1 8 22.168V8.337a1.674 1.674 0 0 1 .406-1.117 1.214 1.214 0 0 1 .948-.479H22.79a1.214 1.214 0 0 1 .948.479 1.674 1.674 0 0 1 .406 1.117s.086 8.47.086 10.387-3.049 5.039-4.828 5.039z",
    transform: "translate(-4 -2.985)",
    style: {
      fill: "#f74945"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22231",
    d: "M3.657 5.667a2.3 2.3 0 0 0 0 3.222l3.829 3.889 3.829-3.889a2.3 2.3 0 0 0 0-3.222 2.219 2.219 0 0 0-3.172 0l-.657.667-.657-.667a2.219 2.219 0 0 0-3.172 0z",
    transform: "translate(4.531 2.355)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25866",
    d: "M9.377 17.143s.039-3.09 1.5-4.776 4.33-1.967 4.33-1.967",
    transform: "translate(4.948 3.616)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
};

export default SvgHeartClipboard;